import { Box } from "@mui/material";
import { MainPageBase } from "./MainPageBase";
import { DamsAppAsset } from "../../assets/registry";

function ConstructionPage() {
  return (
    <MainPageBase
      title="Page Not Ready"
      subtitle="Under Construction"
      pageState="main"
    >
      <Box
        height={`100%`}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box>
          <img
            src={DamsAppAsset.image.under_construction}
            width={200}
            height={200}
          />
        </Box>
      </Box>
    </MainPageBase>
  );
}

export default ConstructionPage;
